export const BACKGROUND_REPEAT_LABELS: string[] = [
  "Don't repeat",
  'Repeat normal',
  'Repeat mirror',
  'Stretch'
];



// WEBPACK FOOTER //
// ./src/data/BackgroundRepeat.ts